// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// semantic-ui
import { Container } from "semantic-ui-react";
import React from "react";
// fragments
import { fragments } from "services/get-fragments";
// mobx
import { observer } from "mobx-react";

export default observer(() => (
  <Container style={{ padding: "40px" }}>
    <fragments.Reports.jsx />
  </Container>
));
